<template>
  <div class="consoleBox">
    <div class="navBox">
      <el-menu
          class="menuNav"
          active-text-color="#fff"
          :default-active="activeRouter"
          unique-opened
          router
      >
        <el-menu-item class="navItem" index="/console/appLink/app/list">
          <svg class="navIcon" aria-hidden="true">
            <use v-show="activeRouter=='/console/appLink/app/list'" xlink:href="#icon-yingyongguanli-copy"/>
            <use v-show="activeRouter!='/console/appLink/app/list'" xlink:href="#icon-yingyongguanli"/>
          </svg>
          <span>统一链接管理</span>
        </el-menu-item>
      </el-menu>
      <el-scrollbar class="menuContent">
        <bread-crumb></bread-crumb>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
        <ICP bgcClor="#fafafa" color="#bdc2c7"></ICP>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import ICP from "@/components/ICP";

export default {
  components: {
    ICP
  },
  created() {
    this.activeRouter = this.$route.meta.menu
        ? this.$route.meta.menu
        : this.activeRouter; //初始化选中路由
  },
  watch: {
    $route(to) {
      this.activeRouter = to.meta.menu ? to.meta.menu : to.path; //切换选中路由
      console.log(this.activeRouter);
    }
  },
  data() {
    return {
      activeRouter: '',
    };
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/ .el-scrollbar__view {
  height: 100%;
  width: 100%;
}

/deep/ .el-breadcrumb__inner {
  display: inline-block;
  font-weight: 700;
  color: black;
  max-width: 120px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.consoleBox {
  padding-top: 64px;
  min-height: calc(100% - 64px); //减头355px(高度+底部)
  width: 100%;

  .navBox {
    display: flex;
    min-height: calc(100% - 64px); //减头355px(高度+底部)
    .menuNav {
      width: 250px;
      min-height: calc(100% - 64px); //减头355px(高度+底部)
      // background-color:rgb(117, 128, 226);
      .navItem {
        height: 80px;
        line-height: 80px;
        font-size: 16px;
        color: #606266;

        .navIcon {
          margin: 0 20px 0 10px;
          width: 1.5rem;
          height: 1.5rem;
          vertical-align: -0.3em;
          fill: currentColor;
          overflow: hidden;
        }
      }

      .is-active {
        background-color: $--color-primary;
      }
    }

    .menuContent {
      box-sizing: border-box;
      flex: 1;
      height: 100%;
      background: #fafafa;
    }
  }
}
</style>

